export default "__VITE_ASSET__875b1a23__"